import React, { useState, useEffect } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import "./formInput.css";

const FormInput = ({
  label,
  placeHolder,
  type,
  value,
  width = "",
  onchange,
  readOnly,
  disabled,
  title,
  icon,
  secIcon,
  name,
  step,
  onclick,
  secIconOnClick,
  iconOnClick,
  prepend, // Added prepend prop
  labelAddon, // optional node rendered next to the label (e.g. info icon)
}) => {
  const isDarkMode = useDarkMode();

  
  return (
    <>
      {label && (
        <label 
          className="form-label"
          style={{
            color: isDarkMode ? "#ffffff" : "#000000"
          }}
        >
          {label}
          {labelAddon}
        </label>
      )}
      <div className="input-group position-relative">
        {prepend && (
          <span
            className="input-group-text"
            style={{
              borderRadius: "10px 0 0 10px",
              border: isDarkMode ? "1px solid #6b7280" : "1px solid #adb5bd",
              borderRight: "none",
              background: isDarkMode ? "#2d3436" : "#F9F9F9",
              height: "44px",
              display: "flex",
              alignItems: "center",
              padding: "0 10px",
              color: isDarkMode ? "#ffffff" : "#6c757d",
              fontSize: "16px",
            }}
          >
            {prepend}
          </span>
        )}
        <input
          type={type}
          value={value}
          readOnly={readOnly}
          disabled={disabled}
          onChange={onchange}
          onClick={onclick}
          step={step}
          name={name}
          title={title}
          className={`form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`}
          placeholder={placeHolder}
          style={{
            ...getCustomFormStyle(isDarkMode),
            ...{ width: width },
            ...(icon && { paddingRight: "40px" }),
            ...(secIcon && icon && { paddingRight: "60px" }),
            ...(prepend && { borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }),
          }}
        />
        {icon && (
          <i
            className={`fa ${icon}`}
            onClick={iconOnClick}
            style={{
              position: "absolute",
              right: secIcon ? "35px" : "15px",
              top: "50%",
              transform: "translateY(-50%)",
              color: isDarkMode ? "#ffffff" : "#6c757d",
              cursor: "pointer",
              zIndex: 2,
            }}
          ></i>
        )}
        {secIcon && (
          <i
            className={`fa ${secIcon}`}
            onClick={secIconOnClick}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#f03a4f",
              cursor: "pointer",
              zIndex: 2,
            }}
          ></i>
        )}
      </div>
    </>
  );
};

const getCustomFormStyle = (isDarkMode) => ({
  borderRadius: "10px",
  background: isDarkMode ? "#2d3436" : "#F9F9F9",
  color: isDarkMode ? "#ffffff" : "#000000",
  height: "44px",
  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
});

export default FormInput;